import React, { useState } from 'react';
import { BooleanParam, useQueryParams } from 'next-query-params';
import Head from 'next/head';
import { useRouter } from 'next/router';

import Box from '@material-ui/core/Box';

import Layout from '../components/book/Layout';
import RadioCardGroup from '../components/shared/RadioCardGroup';

import withAuth from '../modules/WithAuth';
import COPY from '../utils/copy';
import { track } from '../modules/Analytics/helpers';

function Service() {
  const [params, setParams] = useQueryParams({
    truck: BooleanParam,
  });

  const [selected, setSelected] = useState(params.truck !== 'undefined' ? params.truck : undefined);
  const router = useRouter();

  if (selected) {
    track('Choose Service - Truck and Movers', {});
  } else {
    track('Choose Service - Movers Only', {});
  }

  const services = [
    {
      value: true,
      title: 'Truck and Movers',
      description: 'This package includes a team of movers, a 26-foot truck, and a licensed and insured truck driver.',
      icon: {
        alt: 'mover with a truck',
        svg: '/book/icons/service/movers.svg',
      },
    },
    {
      value: false,
      title: 'Movers only',
      description:
        'This package offers only movers, and is perfect for unloading/loading a storage unit or rearranging furniture in your home.',
      icon: {
        alt: 'movers moving a couch',
        svg: '/book/icons/service/labor.svg',
      },
    },
  ];

  return (
    <Layout
      {...COPY.SERVICE}
      button={{
        onClick: () => {
          track('Choose Service - Continue', { service: selected ? 'Truck and Movers' : 'Movers Only' });
          setParams({
            truck: selected,
          });
        },
        isDisabled: selected === undefined,
        isReady: params.truck === selected,
      }}
    >
      <Head>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_BOOKING_SITE_URL}${router.basePath}${router.asPath}`} />
      </Head>
      <Box maxWidth={820} margin="0 auto">
        <RadioCardGroup cards={services} selected={selected} onClick={setSelected} />
      </Box>
    </Layout>
  );
}

export default withAuth(Service);
